import GraphQLClient from 'ts/GraphQLClient'
import { RepoParams } from 'ts/types'
import { Budget, CreateBudgetParams, GetAllBudgetsParams, ReSubmitBudgetParams, SubmitReviewParams } from '../types'
import { CREATE_BUDGET, GET_ALL_BUDGETS, RESUBMIT_BUDGET, SUBMIT_REVIEW } from './graphql'

class BudgetsRepo {
  private client: GraphQLClient

  constructor({ GRAPHQL_URL, ID_TOKEN }: RepoParams) {
    this.client = new GraphQLClient({ url: GRAPHQL_URL, idToken: ID_TOKEN })
  }

  async getBudgets({ year }: GetAllBudgetsParams): Promise<Budget[]> {
    const data = await this.client.request<{
      getAllBudgetsNew: {
        data: Budget[]
        error?: { message: string }
      }
    }>({
      query: GET_ALL_BUDGETS,
      variables: { year }
    })

    const { getAllBudgetsNew } = data

    if (getAllBudgetsNew.error) {
      throw new Error(getAllBudgetsNew.error.message || 'API error')
    }

    return getAllBudgetsNew.data
  }

  async createBudget(params: CreateBudgetParams): Promise<void> {
    await this.client.request({
      query: CREATE_BUDGET,
      variables: params
    })
  }

  async submitReview(params: SubmitReviewParams): Promise<void> {
    await this.client.request({
      query: SUBMIT_REVIEW,
      variables: params
    })
  }

  async reSubmitBudget(params: ReSubmitBudgetParams): Promise<void> {
    await this.client.request({
      query: RESUBMIT_BUDGET,
      variables: params
    })
  }
}

export default BudgetsRepo
